import { useContext } from 'react';
import CompanyContext from 'contexts/company/CompanyContext';

export default function useContextCompany() {
  const context = useContext(CompanyContext);

  if (context === undefined) {
    throw new Error('useContextCompany must be used within a CompanyProvider');
  }

  return context;
}
